import api from '@/api/exercises';
import store from '@/store';

const getSearchConfig = (context, { reqBody, authTokenReq }) =>
  new Promise((resolve, reject) => {
    api
      .getSearchConfig(reqBody, authTokenReq)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const search = (context, { config, authTokenReq }) =>
  new Promise((resolve, reject) => {
    api
      .search(config, authTokenReq)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getResultByPage = (context, { config, sectionId, page }) =>
  new Promise((resolve, reject) => {
    api
      .getResultByPage(config, sectionId, page)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getThematics = (context, classId) =>
  new Promise((resolve, reject) => {
    api
      .getThematics(classId)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getThematicLessons = (context, thematicId) =>
  new Promise((resolve, reject) => {
    api
      .getThematicLessons(thematicId)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getCatalogueCategories = context =>
  new Promise((resolve, reject) => {
    api
      .getCatalogueCategories()
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getCatalogueLessons = (context, catalogueId) =>
  new Promise((resolve, reject) => {
    api
      .getCatalogueLessons(catalogueId)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getVocabularyCategories = (context, requestParams) =>
  new Promise((resolve, reject) => {
    api
      .getVocabularyCategoriesV2(requestParams)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getVocabularyList = (context, requestParams) =>
  new Promise((resolve, reject) => {
    api
      .getVocabularyList(requestParams)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getChatbotCategories = context =>
  new Promise((resolve, reject) => {
    api
      .getChatbotCategories()
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getChatbotLessons = (context, chatbotId) =>
  new Promise((resolve, reject) => {
    api
      .getChatbotLessons(chatbotId)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getGrammarCategories = context =>
  new Promise((resolve, reject) => {
    api
      .getGrammarCategories()
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getGrammarLessons = (context, grammarId) =>
  new Promise((resolve, reject) => {
    api
      .getGrammarLessons(grammarId)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const getBonusLessonByLevel = (context, level) =>
  new Promise((resolve, reject) => {
    api
      .getBonusLessonByLevel(level)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const setCameFromRoute = (context, routeName) =>
  new Promise((resolve, reject) => {
    context.commit('SET_CAME_FROM_ROUTE', routeName);
  });

export default {
  getSearchConfig,
  search,
  getResultByPage,
  getThematics,
  getThematicLessons,
  getCatalogueCategories,
  getCatalogueLessons,
  getVocabularyCategories,
  getVocabularyList,
  getChatbotCategories,
  getChatbotLessons,
  getGrammarCategories,
  getGrammarLessons,
  setCameFromRoute,
  getBonusLessonByLevel
};



// WEBPACK FOOTER //
// ./src/store/modules/exercises/actions.js